import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { TextField } from '@mui/material'

const parseDigitsToFloat = (digits) => {
  if (!digits) return 0
  const num = parseInt(digits, 10)
  return num / 10000
}

// formata manualmente: 1234 → 12,34%
const formatPercent = (digits) => {
  if (!digits) return '0,00%'

  const padded = digits.padStart(3, '0') // garante pelo menos 3 dígitos
  const intPart = padded.slice(0, -2)
  const decimalPart = padded.slice(-2)

  const intFormatted = Number(intPart).toLocaleString('pt-BR')

  return `${intFormatted},${decimalPart}%`
}

function PercentField({ value, onChange, label, max = 1, ...props }) {
  const [digits, setDigits] = useState(() => {
    return value ? Math.round(value * 10000).toString() : '0'
  })

  useEffect(() => {
    if (value !== undefined && value !== null) {
      const newDigits = Math.round(value * 10000).toString()
      setDigits(newDigits)
    }
  }, [value])

  const handleChange = useCallback(
    (event) => {
      const rawValue = event.target.value

      // pega só números
      let inputDigits = rawValue.replace(/[^\d]/g, '')

      if (!inputDigits) inputDigits = '0'

      const floatValue = parseDigitsToFloat(inputDigits)

      if (max != null && floatValue > max) return

      setDigits(inputDigits)

      if (onChange) {
        onChange(floatValue)
      }
    },
    [onChange, max],
  )

  const handleKeyDown = (e) => {
    if (e.key === 'Backspace') {
      e.preventDefault()

      let newDigits = digits.slice(0, -1)
      if (!newDigits) newDigits = '0'

      const floatValue = parseDigitsToFloat(newDigits)

      setDigits(newDigits)

      if (onChange) {
        onChange(floatValue)
      }
    }
  }

  const displayValue = useMemo(() => {
    return formatPercent(digits)
  }, [digits])

  return (
    <TextField
      {...props}
      label={label}
      fullWidth
      variant="outlined"
      value={displayValue}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      type="text"
      inputProps={{ inputMode: 'numeric' }}
    />
  )
}

export default PercentField
